export default __webpack_public_path__ + "static/media/ic-event.961e756f.svg";